/** Better Auth's Eater realm in Nova, see apps/nova/src/auth/eater.ts. */
const BASE_PATH = "/account/api/v1/auth";
// Better Auth's per-IP window, for a 429 that comes without the header.
const DEFAULT_RETRY_AFTER_SECONDS = 60;
export function authError(status, code, retryAfter) {
    switch (code) {
        case "INVALID_EMAIL":
        case "VALIDATION_ERROR":
            return { type: "invalid-email" };
        case "INVALID_OTP":
            return { type: "invalid-code" };
        case "OTP_EXPIRED":
            return { type: "expired-code" };
        case "TOO_MANY_ATTEMPTS":
            return { type: "code-burned" };
        case "OTP_RECENTLY_SENT":
            return { type: "recently-sent" };
    }
    if (status === 429) {
        const seconds = Number(retryAfter);
        return {
            type: "rate-limited",
            rateLimitedFor: retryAfter !== null && Number.isInteger(seconds) && seconds > 0
                ? seconds
                : DEFAULT_RETRY_AFTER_SECONDS,
        };
    }
    return { type: "unexpected" };
}
// Pendolino's eager bundle reaches this module, and Babel compiles it without
// regenerator-runtime, so no async/await here.
function call(path, locale, body) {
    return fetch(`${BASE_PATH}${path}`, {
        method: body ? "POST" : "GET",
        credentials: "same-origin",
        headers: {
            Accept: "application/json",
            "X-Locale": locale,
            ...(body ? { "Content-Type": "application/json" } : {}),
        },
        body: body ? JSON.stringify(body) : undefined,
    }).then((response) => response
        .json()
        .catch(() => null)
        .then((data) => {
        if (response.ok)
            return { ok: true, value: data };
        const code = typeof data === "object" && data !== null && "code" in data
            ? String(data.code)
            : undefined;
        return {
            ok: false,
            error: authError(response.status, code, response.headers.get("X-Retry-After")),
        };
    }), () => ({ ok: false, error: { type: "unexpected" } }));
}
export function createEaterAuthTransport(locale) {
    return {
        session: () => call("/get-session", locale),
        sendCode: (email) => call("/email-otp/send-verification-otp", locale, {
            email,
            type: "sign-in",
        }),
        signIn: (email, code) => call("/sign-in/email-otp", locale, { email, otp: code }),
        signOut: () => call("/sign-out", locale, {}),
    };
}
